import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvironmentBannerComponent } from "./components/environment-banner/environment-banner.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    EnvironmentBannerComponent
],
  template: `
  <app-environment-banner></app-environment-banner>
  <router-outlet></router-outlet>
  `,
  styles: [
    `
    `,
  ],
})
export class App {
 
}
